import useSWR, { SWRResponse } from "swr";
import { IBankAccountsResponse, IUseBankAccounts } from "./types";
import commonSwrConfig from "../commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";
import { IBankAccount } from "@portal/types/api/IBankAccount";
import { commonFetcher } from "../common/commonFetcher";

const useBankAccounts: IUseBankAccounts = () => {
  const { update } = useSession();

  const fetcher = async (url: URL): Promise<IBankAccountsResponse> => {
    return { bankAccounts: await commonFetcher<IBankAccount[]>(url) };
  };

  const { data, error, mutate, isLoading }: SWRResponse<IBankAccountsResponse, unknown> = useSWR(
    "/api/bankAccounts",
    fetcher,
    commonSwrConfig(update),
  );

  return {
    bankAccounts: data?.bankAccounts,
    error: error,
    isLoading: isLoading,
    mutate: mutate,
  };
};

export default useBankAccounts;
